import React from 'react';
import Component from '@vfuk/core-card-carousel';
const CardCarousel = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CardCarousel;
